import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { Status } from '../../../../common/enums/user-status';
import {
  AssignList,
  LookupOptionItem,
} from '../../../../../ui-components/lib/lookup-field/lookup-field-item';
import { DELEGATION_USER_LOOKUP_ASSIGN_LIST } from '../../../employee-flow/account-settings/delegation-tab/delegation-form/delegation-form.constant';

/** The users lookup the reflection builder picks users from: active users only. */
export const REFLECTION_USER_LOOKUP_API = `${ENDPOINTS.Lookup.User}?filters[not_states][0]=${Status.INACTIVE}&filters[not_states][1]=${Status.CANCELLED}&filters[not_states][2]=${Status.DELETED}`;

/** How a users lookup row is shown, with its extra labels translated. */
export function reflectionUserLookupAssignList(
  translate: (key: string) => string
): AssignList {
  return {
    ...DELEGATION_USER_LOOKUP_ASSIGN_LIST,
    extraLabels: DELEGATION_USER_LOOKUP_ASSIGN_LIST.extraLabels.map(item => ({
      ...item,
      label: translate(item.label),
    })),
  };
}

/** Lookup options for stored user ids, named when the label is known and `#id` otherwise. */
export function userLookupOptions(
  ids: unknown,
  labels: Record<number, string>
): LookupOptionItem[] {
  return (Array.isArray(ids) ? ids : [])
    .filter((id): id is number => typeof id === 'number')
    .map(id => ({ value: id, id, label: labels[id] ?? `#${id}` }));
}
